import { render, staticRenderFns } from "./sysconfiglist.vue?vue&type=template&id=02478034&scoped=true"
import script from "./sysconfiglist.vue?vue&type=script&lang=js"
export * from "./sysconfiglist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02478034",
  null
  
)

export default component.exports